"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _immutable = require("immutable");

var _get = _interopRequireDefault(require("transmute/get"));

var _pick = _interopRequireDefault(require("transmute/pick"));

var _ReferenceRecord = _interopRequireDefault(require("reference-resolvers/schema/ReferenceRecord"));

var INTEGRATION_NAME = 'integrationName';
var pickIntegrationName = (0, _pick.default)([INTEGRATION_NAME]);
var getIntegrationName = (0, _get.default)(INTEGRATION_NAME);
var getAppId = (0, _get.default)('appId');
var getError = (0, _get.default)('error');

var formatReferencedObject = function formatReferencedObject(item) {
  return (0, _immutable.fromJS)(getError(item) ? null : pickIntegrationName(item));
};

var _default = function _default(integrationNameResponses) {
  return (0, _immutable.List)(integrationNameResponses.map(function (item) {
    return new _ReferenceRecord.default({
      id: String(getAppId(item)),
      label: getIntegrationName(item),
      referencedObject: formatReferencedObject(item)
    });
  }));
};

exports.default = _default;
module.exports = exports.default;